/**
 * 坐标处理工具函数
 * 提供经纬度格式化等功能
 */

/**
 * 将十进制经纬度转换为度分秒格式
 * @param {number} decimal 十进制经纬度值
 * @param {string} type 类型，'lat'表示纬度，'lng'表示经度
 * @returns {string} 度分秒格式的经纬度字符串
 */
export function convertToDMS(decimal, type) {
  if (decimal === undefined || decimal === null || isNaN(decimal)) {
    return type === 'lat' ? '-- ° -- ′ -- ″ N' : '-- ° -- ′ -- ″ E';
  }
  
  const absolute = Math.abs(decimal);
  const degrees = Math.floor(absolute);
  const minutesNotTruncated = (absolute - degrees) * 60;
  const minutes = Math.floor(minutesNotTruncated);
  const seconds = Math.floor((minutesNotTruncated - minutes) * 60);
  
  const direction = type === 'lat' 
    ? (decimal >= 0 ? 'N' : 'S') 
    : (decimal >= 0 ? 'E' : 'W');
    
  return `${degrees}°${minutes < 10 ? '0' : ''}${minutes}′${seconds < 10 ? '0' : ''}${seconds}″ ${direction}`;
}

/**
 * 格式化航向角度
 * @param {number} cog 航向角度值
 * @returns {string} 格式化后的航向角度字符串
 */
export function formatCog(cog) {
  if (cog === undefined || cog === null) return '0.0';
  return parseFloat(cog).toFixed(1);
}

/**
 * 格式化船速
 * @param {number} sog 船速值(节)
 * @returns {string} 格式化后的船速字符串
 */
export function formatSog(sog) {
  if (sog === undefined || sog === null) return '0.0';
  return parseFloat(sog).toFixed(1);
} 